/* ============================================================
   LCS — PDP behavior
   - Selección de talla (sincroniza chips desktop + sticky mobile)
   - Add to cart vía Shopify Cart AJAX API
   - Estados visuales: agregado / sin stock
   ============================================================ */
(function () {
  'use strict';

  const pdp = document.querySelector('.pdp');
  if (!pdp) return;

  // ---- Variant data (talla → variant_id) ----
  const variantsScript = document.querySelector('[data-pdp-variants]');
  if (!variantsScript) return;
  let variantMap = {};
  try {
    variantMap = JSON.parse(variantsScript.textContent);
  } catch (e) {
    console.error('LCS PDP: variantes mal formadas', e);
    return;
  }

  let selectedSize = null;

  // ---- Sync chips entre desktop (.size-chip) y mobile (.pdp-sticky-cta__chip) ----
  function setSelected(size) {
    selectedSize = size;
    document.querySelectorAll('[data-size-value]').forEach(chip => {
      const isMatch = chip.dataset.sizeValue === size;
      chip.dataset.active = isMatch ? 'true' : 'false';
      chip.setAttribute('aria-pressed', isMatch ? 'true' : 'false');
    });
    updateCtaLabels();
  }

  function updateCtaLabels() {
    const stickyBtn = document.querySelector('.pdp-sticky-cta__btn');
    if (stickyBtn && !stickyBtn.dataset.added && !stickyBtn.dataset.error) {
      stickyBtn.textContent = selectedSize ? 'agregar al carro' : 'elige tu talla';
    }
  }

  document.addEventListener('click', (e) => {
    const chip = e.target.closest('[data-size-value]');
    // Los chips viven en .pdp (desktop) o en .pdp-sticky-cta (mobile, ahora fuera
    // de .pdp porque se renderiza en layout). Aceptamos ambos contextos.
    if (chip && (pdp.contains(chip) || chip.closest('.pdp-sticky-cta'))) {
      const size = chip.dataset.sizeValue;
      // Si está sold out (data-soldout="true"), no permitir seleccionar
      if (chip.dataset.soldout === 'true') return;
      setSelected(size);
    }
  });

  // ---- Add to cart ----
  function flashCta(state, ms = 1800) {
    document.querySelectorAll('[data-pdp-cta]').forEach(btn => {
      btn.dataset[state] = 'true';
      const originalText = btn.textContent;
      if (state === 'added') btn.textContent = btn.classList.contains('pdp-sticky-cta__btn') ? '✓ agregado' : '✓ AGREGADO';
      if (state === 'error') btn.textContent = btn.classList.contains('pdp-sticky-cta__btn') ? 'sin stock' : 'SIN STOCK';
      setTimeout(() => {
        delete btn.dataset[state];
        btn.textContent = originalText;
        updateCtaLabels();
      }, ms);
    });
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count-badge]').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
    document.querySelectorAll('[data-cart-count-text]').forEach(el => {
      el.textContent = count > 0 ? `(${count})` : '(vacío)';
    });
  }

  async function addToCart() {
    if (!selectedSize) {
      // Mobile sticky botón ya muestra "elige tu talla". En desktop, alert simple.
      const isMobile = window.matchMedia('(max-width: 859px)').matches;
      if (!isMobile) alert('selecciona una talla');
      return;
    }
    const variantId = variantMap[selectedSize];
    if (!variantId) {
      console.error('LCS PDP: no hay variant_id para talla', selectedSize);
      flashCta('error');
      return;
    }
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        if (err.status === 422 || (err.description || '').match(/sold out|out of stock/i)) {
          flashCta('error');
        } else {
          throw new Error(err.description || `HTTP ${res.status}`);
        }
        return;
      }
      // Refrescar el HTML del cart drawer + contadores (re-render desde el servidor
      // con los items actualizados). Sin esto el drawer mostraría el cart viejo.
      if (window.LCSShell) {
        if (window.LCSShell.refreshCartUI)    await window.LCSShell.refreshCartUI();
        if (window.LCSShell.refreshCartCount) await window.LCSShell.refreshCartCount();
      } else {
        // Fallback: solo update count si LCSShell no está disponible
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        updateCartCount(cart.item_count);
      }
      flashCta('added');
      // Abrir el cart drawer automáticamente — validación visual instantánea.
      // 250ms de delay para que el "✓ AGREGADO" se vea brevemente antes del slide-in.
      setTimeout(() => {
        if (window.LCSShell && window.LCSShell.openCart) {
          window.LCSShell.openCart();
        }
      }, 250);
    } catch (err) {
      console.error('LCS PDP: error al agregar al carro', err);
      flashCta('error');
    }
  }

  document.addEventListener('click', (e) => {
    const cta = e.target.closest('[data-pdp-cta]');
    if (cta) {
      e.preventDefault();
      addToCart();
    }
  });

  // ===== Size Guide modal =====
  const sizeGuide = document.querySelector('[data-size-guide]');
  function openSizeGuide() {
    if (!sizeGuide) return;
    sizeGuide.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  function closeSizeGuide() {
    if (!sizeGuide) return;
    sizeGuide.hidden = true;
    document.body.style.overflow = '';
  }
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-size-guide-open]')) {
      e.preventDefault();
      openSizeGuide();
      return;
    }
    if (e.target.closest('[data-size-guide-close]')) {
      e.preventDefault();
      closeSizeGuide();
      return;
    }
    // click en el scrim (no en el contenido) cierra
    if (e.target.matches('[data-size-guide]')) {
      closeSizeGuide();
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && sizeGuide && !sizeGuide.hidden) closeSizeGuide();
  });
})();
